import React from "react";

import { SelectEntityByType } from "../../modules/SelectEntityByType/SelectEntityByType";
import { FiltersFieldsTypes } from "../../modules/SelectEntityByType/constants";

export const TemplateSelectorsConditionField = ({ className, name = "condition_code", label = "Condition", ...restProps }) => (
    <SelectEntityByType
        className={className}
        name={name}
        FieldsTypes={FiltersFieldsTypes.templateSelectorCondition}
        label={label}
        {...restProps}
    />
);
